import React, { FC, memo } from 'react'

import { useNavigate } from 'react-router-dom'

import { removeRegisteredUser } from '@sportworld/js-sdk/src/actions/auth'

import { Button } from '@/components/Button/Button'
import { icons } from '@/constants/icons'
import { paths } from '@/constants/paths'
import {
  MobileAppImg,
  MobileAppImgWrapperAccount,
} from '@/containers/Account/styles'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'

import {
  ContentContainer,
  TextElementMain,
  TextElement,
  Column,
  ButtonWrapper,
} from './styles'

const AccountCardsPanelRaw: FC = () => {
  const navigate = useNavigate()
  const { t } = useCommonTranslation()

  const logOut = () => {
    removeRegisteredUser()
  }

  const goToSelfService = () => navigate(`${paths.SELF_SERVICE}`)

  return (
    <ContentContainer>
      <Column>
        <MobileAppImgWrapperAccount>
          <MobileAppImg src={icons.register.mobileAppImage} alt="" />
        </MobileAppImgWrapperAccount>
      </Column>
      <Column>
        <TextElementMain>{t('accountInstruction1')}</TextElementMain>
        <ButtonWrapper>
          <Button text={t('selfservice')} onClick={goToSelfService} />
          <Button text={t('logout')} onClick={logOut} />
        </ButtonWrapper>
        <TextElement>{t('accountInstruction2')}</TextElement>
        <TextElement>
          <span>{t('accountInstructionUrl')}</span>
        </TextElement>
      </Column>
    </ContentContainer>
  )
}
export const AccountCardsPanel = memo(AccountCardsPanelRaw)
